export interface GetDiffOptions {
  baseUrl: string;
  datasetId: string;
  revisionId: string;
}
export interface GetDiffPayload {
  baseUrl: string;
  datasetId: string;
  revisionNumber1: string;
  revisionNumber2: string;
}

export const getDiff = async (options: GetDiffOptions): Promise<any> => {
  const { baseUrl, datasetId, revisionId } = options;
  let url = "";
  if (revisionId == datasetId) {
    url = `${baseUrl}datasets/${JSON.parse(datasetId)}`;
  } else {
    url = `${baseUrl}datasets/revisions/${revisionId}`;
  }
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDiff2 = async (options: GetDiffOptions): Promise<any> => {
  const { baseUrl, datasetId, revisionId } = options;
  let url = "";
  if (revisionId == datasetId) {
    url = `${baseUrl}datasets/${JSON.parse(datasetId)}`;
  } else {
    url = `${baseUrl}datasets/revisions/${revisionId}`;
  }
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchDatasetDiff = async (
  payload: GetDiffPayload
): Promise<any> => {
  const { baseUrl, datasetId, revisionNumber1, revisionNumber2 } = payload;
  const url = `${baseUrl}datasets/${JSON.parse(
    datasetId
  )}/diff?revisionNumber1=${revisionNumber1}&revisionNumber2=${revisionNumber2}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const compareRevisions = async (
  options: GetDiffOptions
): Promise<any> => {
  const { baseUrl, datasetId, revisionId } = options;
  let url = "";

  if (revisionId == datasetId) {
    url = `${baseUrl}datasets/${datasetId}`;
  } else {
    url = `${baseUrl}datasets/revisions/${revisionId}`;
  }
  try {
    const response = await fetch(url);
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};
